import React, { Component } from "react";

import ComponentHOC from "../hoc/ComponentHOC";
import Img from "react-image";
import { Link } from "react-router-dom";
import { MetaTags } from "react-meta-tags";
//Component imports
import Project from "../models/projects";
import facebookShare from "../img/icons/facebook-whitebg-icon.png";
//Images imports
import twitterShare from "../img/icons/twiter-whitebg-icon.png";

class ViewEntertainmentComponent extends Component {
  constructor(props) {
    super(props);
    this.findProjectById = this.findProjectById.bind(this);
  }
  findProjectById(project) {
    var id = this.props.match.params.id;
    return project.pro_id === id;
  }
  render() {
    const { list } = this.props;
    const item = new Project(list.find(this.findProjectById));
    return (
      <section className="view-entertainment-section">
        <MetaTags>
          <title>Millennials Mafia - {item.title}</title>
          <meta name="description" content="Some description." />
          <meta
            property="og:title"
            content={`Millennials Mafia - ${item.title}`}
          />
          <meta property="og:image" content={item.src} />
        </MetaTags>
        <div className="container main-entertainment">
          <div className="row">
            <div className="col-3 d-none d-lg-block thumb">
              <Img src={item.src} alt={item.title} />
            </div>
            <div className="col-12 col-lg-9">
              <article>
                <div className="col-6 d-lg-none float-left thumb">
                  <Img src={item.src} alt={item.title} />
                </div>
                <span className="flag">
                  <Img src={item.flag} alt={item.title} />
                </span>
                <div className="entertainment-header">
                  <h1>{item.title}</h1>
                  <div className="social">
                    <ul>
                      {item.twitterLink ? (
                        <li>
                          <Link to={item.twitterLink}>
                            <Img src={twitterShare} aria-hidden="true" />
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                      {item.facebookLink ? (
                        <li>
                          <Link to={item.facebookLink}>
                            <Img src={facebookShare} aria-hidden="true" />
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </div>
                </div>
                <div className="description">
                  <div dangerouslySetInnerHTML={{ __html: item.description }} />
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ComponentHOC(ViewEntertainmentComponent);



// WEBPACK FOOTER //
// ./src/components/view-entertainment.js